import { render, staticRenderFns } from "./Servicetypeinfo.vue?vue&type=template&id=64f390ca"
import script from "./Servicetypeinfo.vue?vue&type=script&lang=js"
export * from "./Servicetypeinfo.vue?vue&type=script&lang=js"
import style0 from "./Servicetypeinfo.vue?vue&type=style&index=0&id=64f390ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports